import {WEBSOCKET_DISCONNECT, WebsocketAction} from '../middlewares/websockets/types';
import {batch} from 'react-redux';

export const logout = () => (dispatch) => {
  batch(() => {
    dispatch({type: WEBSOCKET_DISCONNECT, isLogout: true});
    dispatch({type: WebsocketAction.FLTR_ADMIN_LOGOUT});
  });
};
